import { useHistory } from 'react-router';
import { Typography } from 'seagull';
import { useTestIds } from 'seagull/utils/TestIds';
import { routes } from "../../../constants";
import { useIoContext, useOverlayContext, useStore, useStoreActions } from "../../../contexts";
import { handleRequest } from "../../../infra/utils";
import { integrationModel } from "../../../models";
import { EmailOnBehalfTypes } from "../../../models/EmailOnBehalfSettingsModel";
import { getEmailProviderDetails, Tab } from "../../../pages/NotificationSettings/NotificationSettings.utils";
import { selectors } from "../../../store/state-selectors";
import gmailLogo from "../../../../assets/Gmail.png";
import IntegrationCard from "../IntegrationCard/IntegrationCard";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
export const deprecatedTestIds = {
  GmailCardTestIds: {
    Root: 'gmail-card',
    ConnectButton: 'gmail-card-connect',
    Tooltip: 'gmail-card-tooltip',
    ErrorToast: {
      StartGmailFlow: 'start-gmail-flow-error-toast',
      NoBusinessId: 'no-business-id-error-toast'
    }
  }
};
export default function GmailCard(_ref) {
  let {
    integration,
    isDisabled
  } = _ref;
  const {
    GmailCardTestIds
  } = useTestIds({
    deprecatedTestIds
  });
  const businessId = useStore(selectors.user.businessId);
  const {
    api
  } = useStoreActions();
  const changeLocation = useIoContext().changeLocation;
  const {
    startLoader,
    stopLoader,
    showErrorToast
  } = useOverlayContext();
  const {
    logBI
  } = useStoreActions();
  const history = useHistory();
  const handleClick = async () => {
    const providerDetails = getEmailProviderDetails(EmailOnBehalfTypes.Gmail);
    if (integrationModel.isLinked(integration)) {
      history.push(routes.notifications, {
        selectedTab: Tab.Client
      });
      return;
    }
    logBI(providerDetails.biCodes.connect, {
      vendorId: businessId
    });
    if (businessId) {
      startLoader();
      const result = await handleRequest(api.notification.emailOnBehalf.connectEmailOnBehalf({
        businessId,
        provider: EmailOnBehalfTypes.Gmail,
        pageUrl: window.location.origin + window.location.pathname
      }));
      if (result.success) {
        changeLocation(result.data);
      } else {
        logBI(providerDetails.biCodes.authError, {
          vendorId: businessId
        });
        showErrorToast("Failed to connect gmail account - please try again", GmailCardTestIds.ErrorToast.StartGmailFlow());
      }
      stopLoader();
    } else {
      logBI(providerDetails.biCodes.authError, {
        vendorId: businessId
      });
      showErrorToast('please refresh and try again', GmailCardTestIds.ErrorToast.NoBusinessId());
    }
  };
  return /*#__PURE__*/_jsx(IntegrationCard, {
    "data-testid": GmailCardTestIds.Root(),
    icon: /*#__PURE__*/_jsx(IntegrationCard.LogoImg, {
      alt: "gmail logo",
      src: gmailLogo
    }),
    title: "Gmail",
    subTitle: "Send client communications through your Gmail mailbox.",
    mainAction: /*#__PURE__*/_jsx(IntegrationCard.MainActionButton, {
      onClick: handleClick,
      "data-testid": GmailCardTestIds.ConnectButton(),
      disabled: isDisabled,
      tooltip: isDisabled ? {
        placement: 'right',
        title: /*#__PURE__*/_jsxs("div", {
          "data-testid": GmailCardTestIds.Tooltip(),
          children: [/*#__PURE__*/_jsx(Typography, {
            variant: "paragraph1",
            skin: "invertedStandard",
            children: "Only one mailbox can be connected at a time."
          }), /*#__PURE__*/_jsx(Typography, {
            variant: "paragraph1",
            skin: "invertedStandard",
            children: "Disconnect Outlook first to connect your Gmail mailbox."
          })]
        })
      } : undefined,
      children: integrationModel.isLinked(integration) ? 'Manage connection' : 'Connect'
    })
  });
}